import { DisciplinaCopiaRequestForm } from "../../../presentation/schemas/Projetos_cadastro/Disciplina_e_SubDisciplina_copia";
import { ICopiaDisciplinasUseCase } from "../../../presentation/useCases/create/copia_disciplinas_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

export class CopiaDisciplinasUseCase implements ICopiaDisciplinasUseCase {
  constructor(private readonly repository: IProjetosRepository) { }

  async copiaDisciplinas(form: DisciplinaCopiaRequestForm): Promise<void> {
    await this.repository.copiaDisciplinas(form);

  }
}


